import * as React from 'react'

import { inject, observer } from 'mobx-react'

import DesktopCommonStore from '~/client/src/desktop/stores/ui/DesktopCommon.store'
import JobsiteHomepageContainerBase from '~/client/src/shared/components/JobsiteHomepageContainer/JobsiteHomepageContainerBase'
import * as Layout from '~/client/src/shared/components/Layout'
import commonRoutes from '~/client/src/shared/constants/commonRoutes'

import ProjectSetUp from '../../views/ProjectSetUp/ProjectSetUp'
import type ProjectSetUpPageStore from '../../views/ProjectSetUp/ProjectSetUpPage.store'
import { ProjectDetailsTabs } from '../../views/ProjectSetUp/ProjectSetUpPage.store'
import ProjectSetUpPage from '../../views/ProjectSetUp/ProjectSetUpPages'
import NavBar from '../NavBar/NavBar'

/**
 * Navigation targets from JHP header edit buttons
 */
type JHPNavigationTarget =
  | 'project-details'
  | 'project-time'
  | 'company-directory'

interface IProps {
  projectSetUpPageStore?: ProjectSetUpPageStore
  common?: DesktopCommonStore
}

/**
 * Desktop JobsiteHomepageContainer - Includes TopNav and ProjectSetUp sidebar
 */
@inject('projectSetUpPageStore', 'common')
@observer
export default class JobsiteHomepageContainer extends React.Component<IProps> {
  /**
   * Handle navigation requests from JHP header edit icons
   */
  private readonly handleNavigate = (target: JHPNavigationTarget): void => {
    const { projectSetUpPageStore } = this.props

    if (!projectSetUpPageStore) {
      console.warn('projectSetUpPageStore not available for navigation')
      return
    }

    switch (target) {
      case 'project-details':
        projectSetUpPageStore.activeTab = ProjectDetailsTabs.Details
        projectSetUpPageStore.navigateTo(ProjectSetUpPage.PROJECT_DETAILS)
        break
      case 'project-time':
        projectSetUpPageStore.activeTab = ProjectDetailsTabs.Time
        projectSetUpPageStore.navigateTo(ProjectSetUpPage.PROJECT_DETAILS)
        break
      case 'company-directory':
        projectSetUpPageStore.navigateTo(ProjectSetUpPage.COMPANY_DIRECTORY)
        break
      default:
        console.warn(`Unknown navigation target: ${target}`)
    }
  }

  /**
   * Handle workflow click from JHP - navigates to Forms page with deep link
   */
  private readonly handleWorkflowClick = (workflowId: string): void => {
    const { common } = this.props

    if (!common) {
      console.warn('common store not available for workflow navigation')
      return
    }

    // Navigate to Forms page with the workflow ID as a deep link parameter
    // The Logistics page will pick this up and open the workflow view dialog
    common._displayView(commonRoutes.FORMS, { form: workflowId })
  }

  public render(): JSX.Element {
    return (
      <Layout.View className="jobsite-homepage-desktop overflow-hidden">
        <Layout.Header className="layout-navigation">
          <NavBar />
        </Layout.Header>
        <Layout.View className="relative overflow-hidden">
          <div className="row full-height">
            <ProjectSetUp
              className="col full-height w-fit-content"
              sidebarOnly
            />
            <div className="col full-height">
              <Layout.Content>
                <div className="relative-block overflow-hidden">
                  <JobsiteHomepageContainerBase
                    onNavigate={this.handleNavigate}
                    onWorkflowClick={this.handleWorkflowClick}
                  />
                </div>
              </Layout.Content>
            </div>
          </div>
        </Layout.View>
        <Layout.Footer>
          <div />
        </Layout.Footer>
      </Layout.View>
    )
  }
}
